import { vslApi } from '@/api';

export default {
  getDebitInfo({ debitSearchNo }) {
    return vslApi.get(`/v1/debits/search?debit_search_no=${debitSearchNo}`, {
      headers: { common: { delayed: true } },
    });
  },
};
